import React, { useState, useEffect } from 'react';

const Countdown = ({ timeDelay, laymisson, value }) => {
    const [timeLeft, setTimeLeft] = useState(timeDelay);

    useEffect(() => {
      setTimeLeft(timeDelay); // Cập nhật timeLeft khi timeDelay thay đổi
    }, [timeDelay]);

    useEffect(() => {
        if (timeLeft <= 0) {
            laymisson(value);
            return;
        }

        const intervalId = setInterval(() => {
            setTimeLeft((prevTime) => prevTime - 1);
        }, 1000);

        return () => clearInterval(intervalId);
    }, [timeLeft]);

    return (
        <div className="text-white text-lg font-bold">
            {timeLeft > 0 ? timeLeft : "WOW"}
        </div>
    );
};

export default Countdown;
